import { getFirestore } from "@firebase/firestore";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyB9WwUR7IsnDfJTXMs-Hg7q4Yzp-K8-Msk",
    authDomain: "praveendev111.firebaseapp.com",
    projectId: "praveendev111",
    storageBucket: "praveendev111.appspot.com",
    messagingSenderId: "573515690888",
    appId: "1:573515690888:web:c838d9f8bfaa1271c0c03d",
    measurementId: "G-NCCXSWVCKR"
  };


const app = initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
